"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapperModal = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = tslib_1.__importStar(require("react"));
var BDSBackdrop_1 = require("../../../common/BDSBackdrop/BDSBackdrop");
var WrapperModal_style_1 = require("./WrapperModal.style");
var WrapperModal = function (props) {
    var propsObj = props;
    var _a = react_1.useState(false), visible = _a[0], setVisible = _a[1];
    react_1.useEffect(function () {
        if (propsObj.isOpen) {
            document.body.style.overflowY = 'scroll';
            document.body.style.width = '100%';
            if (!propsObj.notFixedBody) {
                document.body.style.position = 'fixed';
            }
            setTimeout(function () {
                setVisible(true);
            }, 100);
        }
        else {
            setVisible(false);
            document.body.removeAttribute('style');
        }
        return function () {
            document.body.removeAttribute('style');
        };
    }, [propsObj.isOpen]);
    return (jsx_runtime_1.jsx(react_1.default.Fragment, { children: propsObj.isOpen && (jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "modal-wrap " + (propsObj.type || '') + " " + (visible && 'visible') + " " + ((propsObj === null || propsObj === void 0 ? void 0 : propsObj.isDialogConfirm) && 'confirm-wrapper') + " " + (propsObj.isFitContentWidth ? 'fit-content-width' : ''), css: [WrapperModal_style_1.baseCss] }, { children: [jsx_runtime_1.jsx(BDSBackdrop_1.BDSBackdrop, { handleClick: propsObj.close, style: {
                        zIndex: 99,
                        backgroundColor: propsObj.backgroundColor ? propsObj.backgroundColor : 'rgba(0, 0, 0, 0.6)',
                    } }, void 0),
                jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "modal-contents", style: props.style || {} }, { children: propsObj.children ? propsObj.children : jsx_runtime_1.jsx("div", {}, void 0) }), void 0)] }), void 0)) }, void 0));
};
exports.WrapperModal = WrapperModal;
